/* global google */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'point'];

  static values = {
    path: String
  };

  connect() {
    if (typeof google != 'undefined') {
      this.initializeGooglePlaces();
    }
  }

  get classGuideController() {
    return this.application.getControllerForElementAndIdentifier(
      this.element,
      'classes-guide'
    );
  }

  initializeGooglePlaces() {
    this.autocomplete = new google.maps.places.Autocomplete(this.inputTarget);
    this.autocomplete.setFields(['address_component', 'geometry']);
    this.autocomplete.setComponentRestrictions({ country: ['us'] });
    this.autocomplete.addListener(
      'place_changed',
      this.placeChanged.bind(this)
    );
  }

  placeChanged() {
    let place = this.autocomplete.getPlace();

    if (!place.geometry) {
      return;
    }

    this.pointTarget.value = `${place.geometry.location.lat()},${place.geometry.location.lng()}`;
    this.classGuideController.nextButtonTarget.href = `${
      this.pathValue
    }?q=${encodeURIComponent(this.inputTarget.value)}&point=${
      this.pointTarget.value
    }&${this.getCampaign()}`;
    this.classGuideController.showActions();
  }

  keydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }

  getCampaign() {
    const queryParams = new URLSearchParams(window.location.search);
    let campaign = '';
    if (queryParams.has('campaign')) {
      campaign = queryParams;
    }
    return campaign;
  }
}
